import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { api, errorMessage } from "@/lib/api";
import { SERVICE_TYPES, formatDate } from "@/lib/services";
import { useServices } from "@/context/ServicesContext";

export const DeleteDialog = ({ entry, onClose }) => {
  const { bump } = useServices();

  const confirm = async () => {
    try {
      await api.delete(`/services/${entry.id}`);
      toast.success("Lançamento excluído.");
      bump();
    } catch (err) {
      toast.error(errorMessage(err));
    }
    onClose();
  };

  return (
    <AlertDialog open={!!entry} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent className="border-slate-700 bg-slate-900" data-testid="delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir lançamento?</AlertDialogTitle>
          <AlertDialogDescription>
            {entry && `${entry.client_name} · ${SERVICE_TYPES[entry.service_type].label} · ${formatDate(entry.execution_date)}.`}
            {entry?.status === "realizado" && " O próximo agendamento gerado automaticamente (se ainda pendente) também será removido."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-cancel">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={confirm} className="bg-rose-600 text-white hover:bg-rose-500" data-testid="delete-confirm">Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
